import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    display: 'flex',
    gap: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 0,
    },
  },
  calendarWrapper: {
    ...theme.mixins.appContainer,
    width: 'unset',
    margin: theme.spacing(2),
    display: 'flex',

    '& .MuiPickersToolbar-root': {
      display: 'none',
    },
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: 'transparent',
      color: theme.palette.font.secondary,
    },

    '& .MuiPickerStaticWrapper-content': {
      borderRadius: '10px',
      overflow: 'hidden',
      paddingTop: theme.spacing(4),
    },

    '& .MuiPickersDay-today': {
      border: 'none !important',
    },
    '& .MuiPickersArrowSwitcher-button, & .MuiPickersCalendarHeader-switchViewButton':
      {
        color: theme.palette.text.primary,
      },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(0, 2),
      marginBottom: theme.spacing(1.5),
      backgroundColor: theme.palette.background.paper,
    },
  },

  selectedMonthWrapper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: 0,
      paddingLeft: 0,
      marginBottom: theme.spacing(2),
    },
  },
  day: {
    fontSize: '14px',
    color: theme.palette.font.secondary,
    transition: 'all 0.3s ease',
  },

  viewField: {
    marginTop: theme.spacing(1.5),
  },

  trainingDay: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: theme.palette.primary.contrastText,
    '&.Mui-selected': {
      color: `${theme.palette.primary.contrastText} !important`,
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
    '&:hover': {
      backgroundColor: `${theme.palette.primary.dark} !important`,
    },
  },

  startedTrainingDay: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.font.secondary,
    '&.Mui-selected': {
      color: `${theme.palette.font.secondary} !important`,
    },
    '&.MuiPickersDay-today': {
      border: `1px solid ${theme.palette.primary.main} !important`,
    },
  },

  planedTrainingDay: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.contrastText,
    '&.Mui-selected': {
      color: `${theme.palette.primary.contrastText} !important`,
    },

    '&.MuiPickersDay-today': {
      border: `1px solid ${theme.palette.primary.main} !important`,
    },
  },
}));
